import React from 'react';
import { Property } from '../../domain/entities/Property';
import { GridCard } from './GridCard';

export function GridView({ properties, isLoading, error }: { properties: Property[], isLoading: boolean, error: Error | null }) {
  // TODO helen make sure loading state has empty cards that look good
  // still need to work on responsive design for this view
  // copy redinfs: https://www.redfin.com/city/3879/OH/Cincinnati
  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (properties.length === 0) {
    return <div>No properties found</div>;
  }

  return (
    <div
      id="grid-view"
      className="grid gap-y-4 gap-x-1 p-2 xs:p-4 justify-around xs:grid-cols-[repeat(auto-fill,500px)] overflow-auto"
    >
      {properties.map((p) => <div key={p.id} className="max-w-[490px]"><GridCard property={p} /></div>)}
    </div>
  );
}
